import React from 'react'

const EventHeader = ({ isOpen, className = '', children }) => {
  return (
    <div className={`lbv2__event-header ${isOpen ? "lbv2__event-header--open" : ""} ${className}`}>
      {children}
    </div>
  )
}

export default EventHeader;
